module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/node_modules/axios/index.js
// module id = 315
// module chunks = 0